import { fetchConfig } from '@theme/utilities';
import { CartAddEvent } from '@theme/events';

if (!window.customElements.get('product-card-horizontal')) {
  window.customElements.define('product-card-horizontal', class ProductCardHorizontal extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addToCartButton = this.querySelector('button[type="submit"]');
      this.variantRadios = this.querySelectorAll('input[type="radio"]');
      if (this.addToCartButton) this.addToCartButton.addEventListener('click', (event) => this.handleSubmit(event));
    }

    handleSubmit(evt) {
      const { addToCartTextError } = this.refs;

      evt.preventDefault();
      this.input = this.querySelector('.variant-option--buttons input[type="radio"]:checked');
      if (this.input) {
        this.variantId = this.input.value;
      }

      if (!this.variantId) return;

      let formData = {
        items: [{
          id: this.variantId,
          quantity: 1
        }]
      };

      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      let cartItemComponentsSectionIds = [];
      cartItemsComponents.forEach((item) => {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          cartItemComponentsSectionIds.push(item.dataset.sectionId);
        }
      });
      formData.sections = cartItemComponentsSectionIds.join(',');

      const fetchCfg = fetchConfig('javascript', { body: JSON.stringify(formData) });

      fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => {
          if (!response.ok) {
            return response.json().then(data => {
              throw new Error(data.message || 'Failed to add to cart');
            });
          }

          // If response is ok
          if (response.status) {
            window.dispatchEvent(new CartErrorEvent(this.id, response.message));

            if (addToCartTextError) {
              addToCartTextError.classList.remove('hidden');

              // Reuse the text node if the user is spam-clicking
              const textNode = addToCartTextError.childNodes[2];
              if (textNode) {
                textNode.textContent = response.message;
              } else {
                const newTextNode = document.createTextNode(response.message);
                addToCartTextError.appendChild(newTextNode);
              }

              // Create or get existing error live region for screen readers
              this.setLiveRegionText(response.message);

              this.timeout = setTimeout(() => {
                addToCartTextError.classList.add('hidden');
                this.clearLiveRegionText();
              }, 10000);
            }
          }

          return response.json(); // ✅ always return here if ok
        })
        .then(data => {
          const id = this.dataset.id;
          this.dispatchEvent(
            new CartAddEvent({}, id.toString(), {
              source: 'product-form-component',
              itemCount: formData.items[0].quantity,
              productId: this.dataset.productId,
              sections: data.sections,
            })
          );
        })
        .catch(error => {
          console.error('Add to cart error:', error);
          
        })
        .finally(() => {
          // Reset all variant radio inputs (unchecked)
          this.variantRadios.forEach(input => {
            input.checked = false;
          })
        });
    }

    setLiveRegionText(text) {
      const liveRegion = this.refs.liveRegion;
      liveRegion.textContent = text;
    }

    clearLiveRegionText() {
      const liveRegion = this.refs.liveRegion;
      liveRegion.textContent = '';
    }
  })
}